import React, { useEffect, useRef, useState, FC } from 'react';
import { Container, Button } from 'react-bootstrap';
import { useHistory } from "react-router-dom";
import _ from "lodash";

//Components
import ActivityLoading from '../common/ActivityLoading';
import ActivityModal from '../common/ActivityModal';
import ActivityTable from '../common/ActivityTable';
import ActivityToast from '../common/ActivityToast';

//Types
import { ModalOptionsInterface, TableColumnInterface, TableOptionsInterface, ToastOptionsInterface, UserInterface } from '../common/Types';

//Styles
import '../common/styles.scss';

//Icons
import { FaPencilAlt, FaTrash, FaStickyNote } from 'react-icons/fa';
import { disableMultiUsers, getUsers, deleteUser } from '../../services/UserService';

// const userList: Array<UserInterface> = [
//     { code: "3652", lastName: "Proudmoore", name: "Jaina", admin: true },
//     { code: "4325", lastName: "Wrynn", name: "Varian", admin: true },
//     { code: "8562", lastName: "Saurfang", name: "Varok", admin: true },
//     { code: "2354", lastName: "Bloodhoof", name: "Cairne", admin: true },
//     { code: "9475", lastName: "Menethil", name: "Arthas", admin: false },
// ]

const Users: FC = () => {
    const [modal, setModal] = useState<ModalOptionsInterface>({ open: false, header: "", body: null, buttons: [] });
    const [allUsers, setAllUsers] = useState<Array<UserInterface>>([]);
    const [toastOptions, setToastOptions] = useState<ToastOptionsInterface>({ open: false, message: "" });
    const [users, setUsers] = useState<Array<UserInterface>>([]);
    const [selectedUsers, setSelectedUsers] = useState<Array<string>>([]);
    const [loading, setLoading] = useState(false);

    const history = useHistory();
    let passRef = useRef<any>(null);

    useEffect(() => {
        setLoading(true);
        fetchUsers();
    }, [])

    const fetchUsers = () => {
        getUsers().then((response: any) => {
            response?.sort((a1: any, a2: any) => a1.displayName.localeCompare(a2.displayName));
            setUsers(response as Array<UserInterface>)
            setAllUsers(response as Array<UserInterface>)
            setLoading(false);
        })
    }

    const goToUpdateUser = (user: UserInterface) => {
        history.push({ pathname: `/user/edit/${user.id}` });
    }

    const tableColumns: Array<TableColumnInterface> = [
        { title: "Clave", value: "code" },
        { title: "Nombre", value: "displayName" },
        {
            title: "Administrador",
            value: "admin",
            render: (data: UserInterface) => {
                return data.admin ? "Si" : "No"
            }
        },
        {
            value: "edit",
            render: (data: UserInterface) => (
                <div className="buttons-container-center">
                    <Button size="sm" style={{ margin: '5px' }} onClick={() => goToUpdateUser(data)}>
                        <FaPencilAlt />
                    </Button>
                    <Button size="sm" style={{ margin: '5px' }} onClick={() => handleViewActivities(data)}>
                        <FaStickyNote />
                    </Button>
                    <Button size="sm" style={{ margin: '5px' }} onClick={() => handleDisableUser(data)}>
                        <FaTrash />
                    </Button>
                </div >
            )
        }
    ]

    const handleViewActivities = (user: UserInterface) => {
        history.push({ pathname: '/inscriptions', state: { email: user.email } })
    }

    const handleDisableUser = (user: UserInterface) => {
        setModal({
            open: true,
            header: "Borrar",
            body: "Estas seguro de que quieres borrar este usuario?",
            buttons: [
                { text: "Borrar", func: () => disableUser(user) },
                { text: "Cancel", func: handleModalClose }
            ]
        });
    }

    const disableUser = (user: UserInterface) => {
        setLoading(true);
        deleteUser(user.id)
            .then((response: string) => {
                handleModalClose();
                if (response !== "error")
                    fetchUsers();
            });
    }

    const handleDisableMultiUsers = () => {
        setModal({
            open: true,
            header: "Borrar",
            body: <div>
                <span>{"Estas seguro de que quieres borrar los usuarios seleccionados?"}</span>
            </div>,
            buttons: [
                { text: "Borrar", func: showPasswordModal },
                { text: "Cancel", func: handleModalClose }
            ]
        });
    }

    const showPasswordModal = () => {
        setModal({
            open: true,
            header: "Password",
            body: <div>
                <span>{"Ingrese el password para borrar usuarios?"}</span>
                <input className='search-field' type="password" onChange={(e: any) => handlePassword(e.target.value)} />
            </div>,
            buttons: [
                { text: "Borrar", func: disableUsers },
                { text: "Cancel", func: handleModalClose }
            ]
        });
    }

    const handlePassword = _.debounce((password: string) => {
        passRef.current = { password };
    }, 300);

    const disableUsers = () => {
        const { password } = passRef.current;
        const masterPassword = "M3w01977";

        if (password === masterPassword) {
            setLoading(true);
            disableMultiUsers(selectedUsers)
                .then((response: any) => {
                    handleModalClose();
                    if (response !== "error")
                        fetchUsers();
                });
        } else {
            setToastOptions({ open: true, message: "Contraseña incorrecta" });
        }
    }

    const handleModalClose = () => {
        setModal({ open: false, header: "", body: "", buttons: [] });
    }

    const handleSearch = (search: string) => {
        const filtered = allUsers.filter((usr) => usr?.displayName?.toLowerCase().includes(search.toLowerCase()) || usr?.code?.toString().toLowerCase().includes(search.toLowerCase()));
        setUsers(filtered);
    }

    const handleMultiSelect = (id: string, value: boolean) => {
        let selected = [...selectedUsers];

        if (value) {
            selected.push(id);
        } else {
            selected = selected.filter((sel) => sel !== id);
        }

        setSelectedUsers(selected);
    }

    const tableOptions: TableOptionsInterface = {
        height: 700,
        multiSelect: {
            values: selectedUsers,
            func: (id: string, value: boolean) => handleMultiSelect(id, value)
        },
        search: (data: string) => handleSearch(data),
        // bottomPaginator: (data: any) => console.log(data),
        // topPaginator: (data: any) => console.log(data)
    }

    if (loading) return <ActivityLoading />

    return (
        <Container style={{ marginBottom: '10px' }}>
            <div style={{ marginBottom: '10px' }}>
                <h1>Usuarios</h1>
            </div>
            <ActivityModal {...modal} onClose={handleModalClose} />
            <ActivityToast {...toastOptions} onClose={() => setToastOptions({ open: false, message: "" })} autohide={4000} />
            <div style={{ marginBottom: '15px' }}>
                <Button variant="outline-primary" onClick={() => history.push('/users/newUser')}>Agregar usuario</Button>
                <Button variant="outline-primary" onClick={() => history.push('/users/importUsers')} style={{ marginLeft: '10px' }}>Importar usuarios</Button>
                <Button variant="outline-danger" onClick={() => handleDisableMultiUsers()} style={{ marginLeft: '10px' }}>Borrar usuarios</Button>
            </div>
            <ActivityTable data={users ? users : []} columns={tableColumns} options={tableOptions} />
        </Container>
    )
}

export default Users;
